import { render, staticRenderFns } from "./HomeBrandStrip.vue?vue&type=template&id=2fd3f8c4"
import script from "./HomeBrandStrip.vue?vue&type=script&lang=js"
export * from "./HomeBrandStrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports